import * as z from 'zod';
import { indemnityStatusSchema, indemnityAgreementSignatureMethodSchema } from '../../../../enums.mjs';
import '../../../../types/actor/actor.mjs';
import '../../../../types/address/address.mjs';
import '../../../../types/credit-report/company-credit-report.mjs';
import '../../../../types/credit-report/individual-credit-report.mjs';
import '../../../../types/currency/currency.mjs';
import '../../../../types/entityRelation/entity-relation.mjs';
import '../../../../types/financial-formula/adjustable-value.mjs';
import '../../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../../types/financial-formula/adjustment.mjs';
import '../../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../../types/is-encrypted.mjs';
import '../../../../types/naics-codes/naics-codes.mjs';
import { suretyIndemnityAgreementId, individualContactId, email, companyContactId, userId, isoDateTimeSchema, fileId } from '../../../../types/opaque.mjs';
import '../../../../types/surety/account/requested-limits.mjs';
import '../../../../types/surety/account/surety-account.types.mjs';
import '../../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../../types/surety/application-extraction/application-review.mjs';
import '../../../../types/surety/bond/surety-bond.types.mjs';
import '../../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../../types/surety/quote/surety-quote.types.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../../types/user/user.types.mjs';
import '../../../../types/utils.mjs';

var Get;
(function (Get) {
    (function (Response) {
        const baseSchema = z.object({
            status: indemnityStatusSchema,
        });
        let Incomplete;
        (function (Incomplete) {
            Incomplete.schema = baseSchema.extend({
                id: suretyIndemnityAgreementId,
                status: indemnityStatusSchema.exclude(["complete"]),
                signatureMethod: indemnityAgreementSignatureMethodSchema,
                indemnitors: z.object({
                    companies: z.array(z.object({
                        id: companyContactId,
                        name: z.string(),
                        signerEmail: email.optional(),
                        completed: z.boolean().optional(),
                    })),
                    individuals: z
                        .array(z.object({
                        id: individualContactId,
                        name: z.string(),
                        signerEmail: email.optional(),
                        completed: z.boolean().optional(),
                    }))
                        .default([]),
                }),
            });
        })(Incomplete = Response.Incomplete || (Response.Incomplete = {}));
        let Completed;
        (function (Completed) {
            Completed.schema = Incomplete.schema.extend({
                status: indemnityStatusSchema.extract(["complete"]),
                completedAt: isoDateTimeSchema.optional(),
                completedByUserId: userId.optional(),
            });
        })(Completed = Response.Completed || (Response.Completed = {}));
        Response.schema = z.discriminatedUnion("status", [Incomplete.schema, Completed.schema]);
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Upload;
(function (Upload) {
    (function (Request) {
        Request.schema = z.object({
            fileId: fileId,
        });
    })(Upload.Request || (Upload.Request = {}));
})(Upload || (Upload = {}));

export { Get, Upload };
